import React from "react"
import { FormattedMessage } from "react-intl"
import { useFlags } from "launchdarkly-react-client-sdk"
import { Progress } from "@carrotfertility/carotene-core"
import { PageLayout } from "#/features/global-ui/page-layout"
import { PageHeader } from "#/features/global-ui/page-header"
import { PageNotFound } from "#/components/views/error/PageNotFound"
import { MemberIdError } from "#/pages/member-id/MemberIdError"
import { useMemberProgram } from "#/services/user/hooks/useMemberProgram"
import { ConsumerMemberIdPage } from "#/pages/member-id/ConsumerMemberIdPage"
import { EnterpriseMemberIdPage } from "#/pages/member-id/EnterpriseMemberIdPage"

export default function MemberIdPage(): JSX.Element {
  const { carrotConnectEnabled } = useFlags()
  const { data: memberProgram, isLoading: memberProgramLoading } = useMemberProgram()

  if (!carrotConnectEnabled) {
    return <PageNotFound />
  }

  // Route by program type before product-specific queries fire below. If the
  // program lookup fails, show an error instead of defaulting to Enterprise,
  // to avoid showing Enterprise content to a consumer.
  const header = <PageHeader pageTitle={<FormattedMessage defaultMessage="Member ID" />} />
  if (memberProgramLoading) {
    return (
      <PageLayout header={header}>
        <Progress />
      </PageLayout>
    )
  }
  if (!memberProgram) {
    return (
      <PageLayout header={header}>
        <MemberIdError />
      </PageLayout>
    )
  }
  if (memberProgram.programType === "CONSUMER") {
    return <ConsumerMemberIdPage />
  }
  return <EnterpriseMemberIdPage />
}
